// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox",}[chunkId] || chunkId) + "." + {"182": "9dd40442d5a10172","396": "ca5af56f9b169e63","460": "3275f38e14036bc2","917": "055df35f8397658d","985": "908381eb3700a028",}[chunkId] + ".chunk.js"
}